<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="12" md="8">
        <v-card class="ma-4 pa-2">
          <v-card-title>{{ t('Verificar_Cuenta') }}</v-card-title>
          <!-- Content -->
          <v-card-text>
            <!-- Loading Spinner/Message -->
            <HelperCarregant v-if="loading" :missatge="t('Enviando') + ' ' + t('email')" />

            <!-- Registration Form or Success Message -->
            <template v-if="!loading">
              <!-- Success message if registration is complete -->
              <div v-if="resendComplete">
                <!-- You can style this however you like, for example using v-alert or a plain div -->
                <v-alert type="success" border="left" prominent>
                  {{ t('Se_ha_enviado_un_correo_de_verificacion') }}<br />
                  {{ t('Por_favor_revisa_tu_email_para_continuar') }}
                </v-alert>
              </div>
              <!-- Show the form if registration is not complete -->
              <form v-else @submit.prevent="resend">
                <v-text-field :label="t('Email')" v-model="email" required type="email"></v-text-field>
                <v-btn class="mt-5" type="submit" color="primary" :disabled="loading">
                  {{ t('Enviar_solicitud') }}
                </v-btn>
              </form>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useUiStore   } from '@/stores/ui';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios'
import HelperCarregant from './HelperCarregant.vue'

const { t } = useI18n();
const uiStore   = useUiStore();      // snackbar

const email = ref('')
const loading = ref(false)
const snackbarText = ref('')
const resendComplete = ref(false)


// Resend handler
async function resend() {
  loading.value = true
  try {
    const response = await axios.post('dj-rest-auth/registration/resend-email/', {
      email: email.value,
    })

    // If success response includes "detail", show success message (no redirect)
    if (response.data.detail) {
      snackbarText.value = response.data.detail // e.g. "Se ha enviado un correo de verificación."
      uiStore.triggerSnackbar({ message: snackbarText.value, color: 'success' })
      resendComplete.value = true
    }
  } catch (error) {
    if (error.response) {
      let errorMessages = []
      // Check if response data is an array (e.g., ["This email is already in use."])
      if (Array.isArray(error.response.data)) {
        errorMessages = error.response.data
      }
      // Check if the error message is in the 'detail' attribute
      else if (error.response.data.detail) {
        errorMessages.push(error.response.data.detail)
      }
      // Otherwise, handle field-specific errors (which are usually objects)
      else {
        for (let field in error.response.data) {
          let errorsForField = error.response.data[field]
          if (Array.isArray(errorsForField)) {
            errorMessages.push(...errorsForField)
          } else {
            errorMessages.push(errorsForField)
          }
        }
      }
    } else {
      // No server response or other error
      snackbarText.value = 'An unexpected error occurred.'
    }
    uiStore.triggerSnackbar({ message: snackbarText.value, color: 'error' })
  } finally {
    loading.value = false
  }
}
</script>
  
